export default "__VITE_ASSET__fd2c3b33__"